import { HttpClient,HttpHeaders  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';


@Injectable({
  providedIn: 'root'
})
export class MarketplaceService {
    url:string = environment.nodeserver;

    constructor(private httpClient: HttpClient,public oidcSecurityService: OidcSecurityService ) { }

    prefill(payload: any, interaction: string): Observable<any> {
             let newUrl=environment.PmpUrl;
           let agentId;
           let bearerToken;
           this.oidcSecurityService.getIdToken().subscribe((t)=>{
            bearerToken=t;
           })
           this.oidcSecurityService.getUserData().subscribe((d)=>{
            agentId=d.userId;
           });

           let newInteractionID;
           if(interaction=='1A'){
            newInteractionID='onea';
           }else if(interaction=='2'){
            newInteractionID='two'
           } else if(interaction=='3'){
            newInteractionID='three'
           }else if(interaction=='4'){
            newInteractionID='four';
           }

      const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${bearerToken}`
    });

      return this.httpClient.post(`${newUrl}/${newInteractionID}/mbop/${agentId}`, payload,{ headers: headers });
    }
}